import { ReactNode, SyntheticEvent, useEffect, useState } from 'react'
import { FormControlLabel, Switch } from '@mui/material'

import { useStyles } from './styles'

interface IProps {
  mobile?: boolean
  lable: ReactNode
  name: string
  disabled: boolean
  checked: boolean
  handleChange: (name: string, checked: boolean) => void
  exclusiveGroup?: string
}

export const AccountSwitchButton = ({
  mobile,
  lable,
  name,
  disabled,
  checked,
  handleChange,
  exclusiveGroup,
}: IProps) => {
  const classes = useStyles()
  const [value, setValue] = useState(checked)

  useEffect(() => {
    setValue(checked)
  }, [checked])

  const handleSwitchChange = (_event: SyntheticEvent<Element, Event>, checked: boolean) => {
    if (!exclusiveGroup || checked) {
      setValue(checked)
      handleChange(name, checked)
    }
  }
  return (
    <div className={classes.switchWrapper} style={mobile ? { height: 'fit-content' } : {}}>
      {lable}
      <Switch size="small" checked={value} disabled={disabled} onChange={handleSwitchChange} />
    </div>
  )
}
